import { render, staticRenderFns } from "./SpotMiniWidget.global.vue?vue&type=template&id=51daa5fe&scoped=true&lang=pug&"
import script from "./SpotMiniWidget.global.vue?vue&type=script&lang=ts&"
export * from "./SpotMiniWidget.global.vue?vue&type=script&lang=ts&"
import style0 from "./SpotMiniWidget.global.vue?vue&type=style&index=0&id=51daa5fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51daa5fe",
  null
  
)

export default component.exports